module.exports = __webpack_public_path__ + "img/drh5_title_kr.8daa25b2.png";